import {
    ADD_MODULE_ERROR,
    ADD_MODULE_SUCCESS
    } from "../../actionTypes/authActionTypes";
    
    const reducer = (state = {}, action) => {
      switch (action.type) {
        case ADD_MODULE_SUCCESS:
          return {
            ...state,
            newModuleData: action.payload,
          };
        case ADD_MODULE_ERROR:
          return {
            ...state,
            newModuleError: action.payload,
          };
        default:
          return state;
      }
    };
    
    export default reducer;
    